/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PolarisProjectTemplate } from '@jira/polaris__domain-project/src/ProjectMetadata.types.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

type ProjectId = string;

export const getOnboardingInformation = (projectId: ProjectId): Promise<PolarisProjectTemplate> =>
	fetchJson(
		`/rest/polaris/project-template/onboarding-information/${projectId}?operation=getJpdOnboardingInformation`,
	);
